import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowUpRight, Check } from "lucide-react";
import SEO from "@/components/SEO";
import { BUSINESS } from "@/data/config";

export default function ThankYou() {
  return (
    <>
      <SEO
        title="Request Received | Spokane Gutter Co."
        description="Your quote request was received. We will call you back within one business day."
        path="/thanks"
        noindex
      />
      <section className="min-h-[70vh] flex items-center" data-testid="thanks-page">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-24">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-copper-500 text-ink-950 flex items-center justify-center">
              <Check className="w-5 h-5" strokeWidth={3} />
            </div>
            <p className="overline">Request received</p>
          </div>
          <h1 className="font-display text-5xl sm:text-6xl md:text-8xl tracking-tightest leading-[0.9] mb-8 max-w-3xl">
            Thanks. We will call you back within one business day.
          </h1>
          <p className="text-bone-300 text-lg max-w-lg mb-10">
            If it is urgent, call us direct and we will pick up or call right back.
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href={BUSINESS.phoneHref}
              data-testid="thanks-call-cta"
              className="inline-flex items-center gap-2 bg-copper-500 hover:bg-copper-600 text-ink-950 hover:text-white font-heading font-semibold px-6 py-3 rounded-sm transition-colors duration-200"
            >
              <Phone className="w-4 h-4" /> Call {BUSINESS.phone}
            </a>
            <Link
              to="/"
              data-testid="thanks-home-link"
              className="inline-flex items-center gap-2 border border-white/15 hover:border-copper-500 text-bone-50 font-heading font-semibold px-6 py-3 rounded-sm transition-colors duration-200"
            >
              Back to home <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
